/**
 * Type guard to check if error is your app’s normalized ApiError
 */
export function isAppApiError(error) {
    return (typeof error === 'object' &&
        error !== null &&
        'message' in error &&
        ('status' in error || 'code' in error));
}
/**
 * Type guard to check if error is an Axios HTTP error
 */
export function isAxiosHttpError(error) {
    return (typeof error === 'object' &&
        error !== null &&
        'isAxiosError' in error &&
        error.isAxiosError === true);
}
